import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import {
    DocumentCheckIcon,
    ClockIcon,
    ShieldCheckIcon,
    MapPinIcon,
    UsersIcon,
    BuildingOfficeIcon,
    CalendarIcon,
    CurrencyRupeeIcon,
    CheckCircleIcon,
    StarIcon,
    HeartIcon,
    LightBulbIcon,
    RocketLaunchIcon
} from '@heroicons/react/24/outline';

// Icon mapping
const iconMap = {
    DocumentCheckIcon,
    ClockIcon,
    ShieldCheckIcon,
    MapPinIcon,
    UsersIcon,
    BuildingOfficeIcon,
    CalendarIcon,
    CurrencyRupeeIcon,
    CheckCircleIcon,
    StarIcon,
    HeartIcon,
    LightBulbIcon,
    RocketLaunchIcon
};

const FeatureCard = ({ feature, onEdit, onDelete }) => {
    const IconComponent = iconMap[feature.icon_name] || CheckCircleIcon;

    return (
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 border border-slate-100">
            {/* Feature Preview */}
            <div className={`p-6 ${feature.bg_color_class || 'bg-green-50'}`}>
                <div className="flex items-center justify-between">
                    <div className={`w-16 h-16 rounded-2xl flex items-center justify-center bg-white shadow-sm`}>
                        <IconComponent className={`h-8 w-8 text-${feature.color_class || 'green'}-600`} />
                    </div>

                    {/* Display Order Badge */}
                    <div className="bg-white rounded-lg px-3 py-1.5 shadow-lg">
                        <span className="text-sm font-bold text-primary-600">
                            #{feature.display_order || 0}
                        </span>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="p-5">
                {/* Active Badge */}
                <div className="mb-3">
                    <span className={`px-3 py-1.5 rounded-lg text-xs font-semibold ${feature.is_active
                            ? 'bg-green-100 text-green-600'
                            : 'bg-slate-100 text-slate-500'
                        }`}>
                        {feature.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-slate-800 mb-2 line-clamp-1">
                    {feature.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-slate-500 mb-4 line-clamp-2">
                    {feature.description}
                </p>

                {/* Icon Name Tag */}
                <div className="mb-4">
                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs font-medium rounded-md">
                        {feature.icon_name}
                    </span>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2 pt-4 border-t border-slate-100">
                    <button
                        onClick={() => onEdit(feature)}
                        className="flex-1 flex items-center justify-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <PencilIcon className="h-4 w-4" />
                        Edit
                    </button>
                    <button
                        onClick={() => onDelete(feature.id)}
                        className="flex-1 flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <TrashIcon className="h-4 w-4" />
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeatureCard;
